<template>
  <div class="modal auto_adjust popup deletinfoPopup">
    <div class="modal--backdrop" @click="dismiss(false)"></div>
    <div class="modal--content min--width--30">
      <div class="modal--header">
        <h4 class="text-white m-0">Delete Post</h4>
      </div>
      <div class="modal--body pb-4">
        <div id="loginform">
          <div class="row">
            <div class="col-lg-10 col-xl-10 mx-auto">
              <div class="blockusercontent text-center mb-4">
                <p>Are you sure you want to delete this post?</p>
                <p>You cannot undo it after deletion.</p>
              </div>
              <div class="loginbtn">
                <button v-if="isLoading" class="btn btn--primary mb-3">
                  <div class="loader"></div>
                </button>
                <button
                  v-else
                  @click.once="dismiss(true)"
                  class="btn btn--primary mb-3"
                >
                  Confirm
                </button>
                <a @click="dismiss(false)" href="javascript:;">Cancel</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { usePosts } from "../../composables/posts.composables";
import { popModal, Modal } from "jenesius-vue-modal";
import { defineComponent, ref } from "vue";

export default defineComponent({
  props: ["postId"],
  components: {},
  emits: [Modal.EVENT_PROMPT],
  setup(props, { emit }) {
    const isLoading = ref<boolean>(false);
    const { deletePost } = usePosts();

    const dismiss = async (val: boolean) => {
      if (val) {
        isLoading.value = true;
        await deletePost(props.postId);
        isLoading.value = false;
      }
      emit(Modal.EVENT_PROMPT, {
            close: val,
        });
      popModal();
    };

    return {
      isLoading,
      dismiss,
    };
  },
});
</script>
<style lang="scss" scoped>
.deletinfoPopup {
  .modal--content {
    width: 420px;
    background: var(--base-regular) 0 0 no-repeat padding-box;
    box-shadow: 0 11px 43px rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    margin: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-flow: column;
    max-height: max-content;
    height: auto;
  }
  .modal--header {
    padding: 20px;
    color: var(--text-color);
    text-align: center !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    border-bottom: 1px solid hsla(0, 0%, 43.9%, 0.3019607843);
    h4 {
      font-size: 16px;
      font-weight: 600;
      margin: 0px;
      line-height: 1;
      letter-spacing: 0px;
      padding: 0px;
      color: var( --base-text-white);
      text-align: center;
    }
  }
  .modal--body {
    flex-grow: 1;
    overflow: hidden auto;
    padding: 0 20px;
    p {
      font-weight: 400;
      letter-spacing: 0px;
      color: var(--base-text-white);
      opacity: 0.5;
      margin-bottom: 0.5rem;
      display: inline-block;
      font-size: 16px;
      margin: 0px 0px 10px;
      padding: 0px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .loginbtn button {
      background: linear-gradient(45deg, #b946d7 0%, #2aafdc 100%);
      padding: 10px 0;
      font-weight: 500;
      font-size: 14px !important;
      margin-bottom: 1rem !important;
    }
    a {
      text-decoration: none;
    }
  }
  .pb-4 {
    padding-bottom: 1.5rem !important;
  }
}
.loginbtn {
  button {
    background: linear-gradient(45deg, #b946d7 0%, #2aafdc 100%);
    border: 1px solid #a28f8f;
    padding: 10px 0;
    border-radius: 10px;
    font-weight: 500;
    font-size: 14px !important;

    color: var(--text-color);
  }
}
.loginbtn {
  a {
    border: 1px solid var(--text-color);
    padding: 10px 0;
    border-radius: 10px;
    font-weight: 500;
    text-align: center;
    color: var(--text-color);
    background-color: transparent;
    width: 100%;
    display: inline-block;
  }
}
.blockusercontent {
  p {
    color: var(--base-text-white) !important;
    font-size: var(--font-lg);
  }
}
</style>
